export default "__VITE_PUBLIC_ASSET__638e4dfa__"